package com.exura.features.newauth.di

import com.exura.features.firebase.usecase.GetUserDataPrefixUseCase
import com.exura.features.newauth.data.repository.ProviderFirebaseAuthRepository
import com.exura.features.newauth.domain.manager.AuthManager
import com.exura.features.newauth.domain.manager.ProviderAuthManager
import com.exura.features.newauth.usecase.RandomRegisterProviderUseCase
import kotlinx.coroutines.CoroutineScope
import org.koin.dsl.module

val providerAuthModule = module {

    // Auth repositories
    single { ProviderFirebaseAuthRepository(get()) }

    // Auth manager
    single<AuthManager> { ProviderAuthManager(get(), get<CoroutineScope>()) }

    factory { GetUserDataPrefixUseCase(get(), get()) }
    factory { RandomRegisterProviderUseCase(get(), get()) }
}
